import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import designerImg from '@/assets/home_designerArrow.svg';
import developerImg from '@/assets/home_developerArrow.svg';
import { translate } from '@/translations';
import { logContactClick } from '@/utils/analytics-utils';
import { scrollToElement } from '@/utils/scroll-to-element';

export const IntroSection = () => {
  const [init, setInit] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation('home');

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  return (
    <div className="grid w-auto relative full-page-section overflow-hidden">
      {init && (
        <Particles
          id="tsparticles"
          options={{
            background: {
              color: {
                value: '#ffffff',
              },
            },
            fullScreen: {
              enable: false,
              zIndex: -1,
            },
            fpsLimit: 120,
            particles: {
              color: {
                value: '#aeaeae',
              },
              links: {
                color: '#aeaeae',
                distance: 150,
                enable: true,
                opacity: 0.5,
                width: 1,
              },
              move: {
                direction: 'none',
                enable: true,
                outModes: {
                  default: 'bounce',
                },
                random: false,
                speed: 1,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                },
                value: 40,
              },
              opacity: {
                value: 0.5,
              },
              shape: {
                type: 'circle',
              },
              size: {
                value: { min: 1, max: 5 },
              },
            },
            detectRetina: true,
          }}
          className="absolute top-0 left-0 right-0 bottom-0 z-0 p-0 m-0"
        />
      )}

      <div className="text-4xl md:text-5xl xl:text-7xl font-bold z-10">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr_1fr] justify-items-center w-full items-end mt-32">
          <div className="max-w-md md:max-w-full w-full pl-2 md:pr-10">
            <div className="relative justify-self-start md:justify-self-end w-20 h-5 md:w-28 md:h-8 xl:w-32 xl:h-10 bg-button rounded-full">
              <p className="flex justify-center items-center w-20 h-5 md:w-28 md:h-7 xl:w-32 xl:h-10 text-white text-xs md:text-base xl:text-lg font-light whitespace-nowrap">
                You
              </p>
              <img
                src={designerImg}
                className="absolute -right-5 -bottom-1"
                alt={translate('images:designer')}
                loading="lazy"
              />
            </div>
          </div>

          <div className="justify-self-center relative w-full pt-2 xl:pt-7">
            <h1 className="mb-1 xl:mb-3 text-center md:whitespace-nowrap">
              Your Ideas, Our Craft.
            </h1>
          </div>
        </div>

        <div className="grid grid-rows-1 mt-3">
          <div className="flex lg:flex-row flex-col justify-center items-center gap-3 lg:gap-0">
            <h1 className="pr-5 xl:pr-10 text-center mt-3 md:whitespace-nowrap">
              Custom Software by Skilled
            </h1>
            <div className="flex justify-center md:pr-16">
              <div className="custom-frame relative inline-block md:w-auto px-2 xl:px-6 border border-red-500">
                <div className="custom-frame2">
                  <h1 className="text-[#7000FE] text-center pb-2 md:pb-4 xl:pb-6">Craftsmen</h1>
                </div>
                <div className="absolute w-20 h-5 md:w-24 md:h-8 xl:w-32 xl:h-10 -right-16 -bottom-4 md:-right-16 md:-bottom-6 lg:-right-20 lg:-bottom-6 bg-[#01ACFE] rounded-full">
                  <p className="flex justify-center items-center w-20 h-5 md:w-24 md:h-7 xl:w-32 xl:h-10 pb-0.5 text-white text-xs md:text-base xl:text-lg font-light">
                    Developer
                  </p>
                  <img
                    src={developerImg}
                    className="absolute -left-4 -top-2"
                    alt={translate('images:developer')}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-subtitle mt-4 z-10 ">
        <p>{t('subtitle')}</p>
      </div>

      <div className="flex justify-center w-auto">
        <button
          className="action-button z-10"
          onClick={() => {
            logContactClick('Home_IntroSection', t('topContactButton'));
            scrollToElement('contact-section');
          }}
        >
          {t('topContactButton')}
        </button>
      </div>
    </div>
  );
};
